import { createContext } from "react"

export const TaskOperationsContext = createContext({})
